import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import EquityImg from "../../../Images/product-equity.png";
import "./ProductWhyEquity.css";
function ProductWhyEquity() {
  return (
    <>
      <section className="why-equity-block">
        <Container className="add-border">
          <Row>
            <Col lg={12} md={12} sm={12}>
              <div className="why-equitie-inn">
                <h3>
                  <span>Why Equity?</span>
                </h3>
                <p>
                  The biggest advantage of investing in stock is the prospect of exponentially growing the principal invested amount. Equity investments have the potential of providing inflation-adjusted positive return with greater liquidity. Moreover it also provides excellent portfolio diversity and can serve as an additional source of income.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default ProductWhyEquity;
